import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import Price, * as Prices from 'theme/atoms/Price'
import B2cSwitch from 'theme/atoms/B2cSwitch'
import { Product } from 'utils/productListFetcher/types'

type Props = {
  productData: Product
}

export default function HotspotItemPrice(props: Props) {
  const prices = props.productData.prices

  if (!prices) return null
  return (
    <Wrapper className="HotspotItemPrice">
      <div className="labels">
        <Price prices={prices} logic="piece" />

        {Prices.PriceHasStrikePrice(props.productData, 1) && (
          <span className="strike" data-cy-state="has-strikeprice">
            <Prices.PriceStrike prices={prices} logic="piece" />
          </span>
        )}
      </div>
      <div className="details">
        {props.productData.unit.purchaseUnit > 1 && (
          <div data-cy-state="has-purchaseUnit-greater-one">
            <span>
              <Price
                prices={props.productData.prices}
                logic="pack"
                scalePrice={props.productData.priceRules}
              />
              {' / '}
              {props.productData.unit.purchaseUnit}{' '}
              {props.productData.unit.unitName}
            </span>
          </div>
        )}
        {props.productData.prices.referencePriceNetString && (
          <span data-cy-state="has-baseprice">
            <B2cSwitch.B2B>
              {props.productData.prices.referencePriceNetString}
            </B2cSwitch.B2B>
            <B2cSwitch.B2C>
              {props.productData.prices.referencePriceGrossString}
            </B2cSwitch.B2C>
          </span>
        )}
      </div>
    </Wrapper>
  )
}

export const Wrapper = styled.div`
  margin-top: ${theme.spacing('s')};
  display: flex;
  flex-direction: column;
  ${theme.ty('r-xs', '700', 'r-base')}
  color: ${theme.colors.shade.b2};

  > .labels {
    ${theme.ty('r-s', '700', 'r-base')}
    > .strike {
      margin-left: ${theme.spacing('xxs')};
    }
  }
  > .details {
    ${theme.ty('r-xs', '400', 'r-s')}
    color: ${theme.colors.shade.b2};
  }
`
